var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},[_c('transition-group',{staticClass:"messagesContainer",attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.getMessageLastItem),function(message){return _c('div',{key:message.id,staticClass:"message",class:[ message.success ? 'message-success' : 'message-fail' ]},[_vm._v(_vm._s(message.text))])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }